import { createContext, useContext } from 'react';

/**
 * True inside `<IndexListView>`.
 *
 * A list row and a table row read the same `ColumnDef`s, but a list row is two lines tall
 * and a table row is one. The avatar is the difference: in a table row it belongs beside the
 * single line of text, in a list row it stands to the left of both lines. The list hoists it
 * out of the anchor and renders it itself, so `<AvatarCell>` drops its own copy here rather
 * than drawing a second.
 *
 * Same shape as `IndexTableSurfaceContext` — a cell asks which surface it is on rather than
 * every page passing a flag down.
 */
export const ListSurfaceContext = createContext(false);

export function useListSurface(): boolean {
  return useContext(ListSurfaceContext);
}
